import { actions } from 'react-redux-form';

const reduxFormAction = ({model, key, actionType='', value}) => {
  const field = `${model}.${key}`;
  return actions[actionType](field, value);
};

export const fieldToMerge = (args) => {
  return reduxFormAction({...args, actionType: 'change'});
};

export const fieldToReset = (args) => {
  return reduxFormAction({...args, actionType: 'reset'});
};

export const pushToArray = (args) => {
  return reduxFormAction({...args, actionType: 'push'});
};

export const removeFromArray = (args) => {
  return reduxFormAction({...args, actionType: 'remove'});
};

export const mergeWithSubmissionModel = ({dispatch, googleInfo, model}) => {
  for (const key in googleInfo) {
    if (googleInfo.hasOwnProperty(key)) {
      const value = googleInfo[key];

      dispatch(fieldToMerge({model, key, value}));
    }
  }
};
